import { isRouteErrorResponse, useRouteError } from 'react-router'

export const ErrorPage = () => {
  const error = useRouteError()

  return (
    <div
      style={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minBlockSize: '100svb',
        position: 'relative',
      }}
    >
      <main
        style={{
          boxSizing: 'border-box',
          inlineSize: '100%',
          marginBlock: 'auto',
        }}
      >
        <div
          style={{
            boxSizing: 'border-box',
            paddingInline: 0,
            paddingBlock: 'clamp(40px, 26px + 3.85vi, 80px)',
          }}
        >
          <div
            style={{
              boxSizing: 'border-box',
              marginBlock: 0,
              marginInline: 'auto',
              paddingBlock: 0,
              paddingInline: 24,
              inlineSize: '100%',
              maxInlineSize: 800,
            }}
          >
            <div
              style={{
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: 24,
              }}
            >
              <div
                style={{
                  boxSizing: 'border-box',
                  minInlineSize: 1,
                }}
              >
                <h1
                  style={{
                    boxSizing: 'border-box',
                    fontSize: 'clamp(1.25rem, 1.077rem + 0.77vi, 1.75rem)',
                    fontWeight: 700,
                    color: '#586464',
                    display: 'flex',
                    marginBlock: 0,
                    marginInline: 0,
                  }}
                >
                  <span
                    style={{
                      boxSizing: 'border-box',
                      display: 'block',
                    }}
                  >
                    {isRouteErrorResponse(error)
                      ? error.status === 404
                        ? 'ページが見つかりませんでした'
                        : error.statusText
                      : error instanceof Error
                        ? 'エラーが発生しました'
                        : '予期せぬエラーが発生しました'}
                  </span>
                </h1>
              </div>
              <div
                style={{
                  boxSizing: 'border-box',
                  paddingBlock: 'clamp(24px, 18px + 1.54vi, 40px)',
                  paddingInline: 'clamp(24px, 18px + 1.54vi, 40px)',
                  borderRadius: 4,
                  backgroundColor: '#fff',
                  minInlineSize: 1,
                }}
              >
                <div
                  style={{
                    boxSizing: 'border-box',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: 24,
                  }}
                >
                  <div
                    style={{
                      boxSizing: 'border-box',
                      minInlineSize: 1,
                    }}
                  >
                    <p
                      style={{
                        boxSizing: 'border-box',
                        fontSize: 'clamp(0.875rem, 0.832rem + 0.19vi, 1rem)',
                        textAlign: 'center',
                        marginBlock: 0,
                        marginInline: 0,
                      }}
                    >
                      {isRouteErrorResponse(error) ? (
                        error.status === 404 ? (
                          <>
                            お探しのページは削除されたか、一時的にご利用できない可能性があります。
                            <br />
                            お探しのページのURLが正しいかどうかご確認ください。
                          </>
                        ) : (
                          error.data
                        )
                      ) : error instanceof Error ? (
                        error.message
                      ) : (
                        '予期せぬエラーが発生しました'
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      boxSizing: 'border-box',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minInlineSize: 1,
                    }}
                  >
                    <a
                      href="/"
                      style={{
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        blockSize: 'auto',
                        borderRadius: 4,
                        display: 'inline-flex',
                        inlineSize: 'auto',
                        justifyContent: 'flex-start',
                        marginBlock: 0,
                        marginInline: 0,
                        position: 'relative',
                        textAlign: 'start',
                        textDecoration: 'none',
                        borderBlock: 'none',
                        borderInline: 'none',
                        boxShadow: '0 2px 2px rgb(0 0 0 / 24%)',
                        paddingBlock: 12,
                        paddingInline: 'clamp(24px, 21px + 0.77vi, 32px)',
                        fontSize: 'clamp(0.75rem, 0.707rem + 0.19vi, 0.875rem)',
                        fontWeight: 700,
                        color: '#fff',
                        background: 'linear-gradient(90deg, oklch(74.9% 0.118 183.4) 0, oklch(78.5% 0.175 155.1) 100%)',
                      }}
                    >
                      <span
                        style={{
                          boxSizing: 'border-box',
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{
                            boxSizing: 'border-box',
                            display: 'block',
                          }}
                        >
                          トップページに戻る
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
